export function getMarkAsReadEndpoint(eventMessageIds: string[]) {
  let baseUrl = '/user/events/markasread';
  let searchParams = new URLSearchParams();

  eventMessageIds.forEach((id) => {
    searchParams.append('ids', id);
  });

  return `${baseUrl}?${searchParams.toString()}`;
}
